import { currencyFormatter } from "utils/currencyHelper";

export function getTotalPool(jackpotPool, game, isJackpotBanner){
    let totalJackpot = 0;
    let balanceView = isJackpotBanner ? "balance" : "jackpotBalance";
    
    let gameBalance = 0;
    if(game && typeof game.get === 'function') {
        const balanceValue = game.get(balanceView);
        if(balanceValue !== undefined && balanceValue !== null && balanceValue !== '') {
            const num = Number(balanceValue);
            if(!isNaN(num)) {
                gameBalance = num;
            }
        }
    }
    
    let currency = '';
    if(this && this.props && this.props.currency) {
        currency = this.props.currency;
    }
    
    if(jackpotPool !== null && jackpotPool !== undefined && jackpotPool) {
        if(typeof jackpotPool === 'object') {
            const values = Object.values(jackpotPool);
            for(let i = 0; i < values.length; i++) {
                const value = values[i];
                if(value && typeof value === 'object') {
                    const amountValue = value.amount;
                    if(amountValue !== undefined && amountValue !== null && amountValue !== '') {
                        const amount = Number(amountValue);
                        if(!isNaN(amount)) {
                            totalJackpot += amount;
                        }
                    }
                }
            }
        }
    }
    
    let finalAmount = 0;
    if(jackpotPool !== null && jackpotPool !== undefined) {
        finalAmount = gameBalance > totalJackpot ? gameBalance : totalJackpot;
    } else {
        finalAmount = gameBalance;
    }
    
    if(finalAmount <= 0 || isNaN(finalAmount)) {
        return "";
    }
    
    const params = {};
    if(currency) {
        params.currency = currency;
    }
    
    return currencyFormatter(finalAmount, params);
}
